import { AiFixButton } from './AiFixButton';
import { ArchiveIssueButton } from './ArchiveIssueButton';
import { RestoreIssueButton } from './RestoreIssueButton';
import { SnoozeIssueButton } from './SnoozeIssueButton';
import { Space } from 'antd';
import { usePeriscopeActions } from '@hooks';
import { When } from 'react-if';
import { ActiveIndicator, PeriscopeSource } from '@ui/icons';
import { IssueVisibilityType } from '@sonar-software/sonar-issues';
import React, { useCallback } from 'react';
export const IssueHeader = ({ hideActions, issue, visibility }) => {
    const { active, id, object, sonarObjectType, sourceUrl } = issue;
    const { openPeriscope } = usePeriscopeActions();
    const handleTitleClick = useCallback((e) => {
        const targetElementClasses = e.target.classList;
        if (targetElementClasses.contains('ant-card-head-title') ||
            targetElementClasses.contains('title-button') ||
            targetElementClasses.contains('issue-label')) {
            openPeriscope({
                id,
                name: object,
                openedFromIndex: -1,
                type: sonarObjectType
            });
        }
    }, [openPeriscope, id, object, sonarObjectType]);
    const displayName = `${object} - ${name}`;
    const showRestore = visibility === IssueVisibilityType.Archived || visibility === IssueVisibilityType.Snoozed;
    return (React.createElement("div", { className: 'title-button', onClick: handleTitleClick },
        React.createElement("div", { className: 'ant-card-head-title' },
            React.createElement(Space, { align: 'baseline', wrap: true },
                React.createElement("span", { className: 'issue-label' }, displayName),
                React.createElement(ActiveIndicator, { isActive: active }),
                React.createElement(PeriscopeSource, { id: `issue-sf-link-${id}`, sonarObjectType: sonarObjectType, url: sourceUrl })),
            React.createElement(When, { condition: !hideActions },
                React.createElement(Space, { className: 'issue-actions' },
                    !showRestore &&
                        React.createElement(React.Fragment, null,
                            React.createElement(SnoozeIssueButton, { sonarObjectId: id }),
                            React.createElement(ArchiveIssueButton, { sonarObjectId: id })),
                    showRestore && React.createElement(RestoreIssueButton, { sonarObjectId: id }),
                    React.createElement(AiFixButton, { sonarObjectId: id }))))));
};
